import { useEffect, useRef, useState } from "react";
import './Footer.css';

interface FooterProps {
    customerFeedback: string[];
    showFeedback: boolean;
}

export default function Footer(props: FooterProps) {


    const [scrollSpeed, setScrollSpeed] = useState<number>(30); // Default scroll speed
    const footerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Calculate the width of the entire content to adjust the scroll speed
        if (footerRef.current) {
            const contentWidth = footerRef.current.scrollWidth;
            const viewportWidth = window.innerWidth;

            // Set the speed based on the content width: larger content scrolls slower
            const newScrollSpeed = (contentWidth / viewportWidth) * 30; // 40s is a base value
            setScrollSpeed(newScrollSpeed);
        }
    }, [props.customerFeedback]); // Re-run when customerFeedback changes

    if (!props.showFeedback) {
        return null;
    }

    return (
        <footer className="footer">
            <div className="footer-inner" ref={footerRef} style={{ animationDuration: `${scrollSpeed}s` }}>
                {props.customerFeedback.map((feedback, index) => (
                    <div key={index} className="feedback-item">{feedback}</div> // Wrap feedback in a div or span
                ))}
            </div>
        </footer>
    );
}
